import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class PlanilhaService {
    private urlModulo = `${environment.urlAPI}/planilha`;

    constructor(private http: HttpClient) { }

    /**
     * Recupera planilha por código da auditoria
     */
    public getPlanilha(codAuditoria: number): Promise<any> {
        const params = new HttpParams().set('codAuditoria', codAuditoria.toString());
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}`, { params, responseType: 'blob' })
                .subscribe({
                    next: (response: any) => {
                        resolve(response);
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera planilha preenchida por código da auditoria
     */
    public getPlanilhaPreenchida(codAuditoria: number): Promise<any> {
        const params = new HttpParams().set('codAuditoria', codAuditoria.toString());
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-preenchida`, { params, responseType: 'blob' })
                .subscribe({
                    next: (response: any) => {
                        resolve(response);
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Carrega/salva dados da planilha
     */
    public carregaPlanilha(planilhaData: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-carregar`, planilhaData)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }
}


// WEBPACK FOOTER //
// /app/src/app/services/planilha.service.ts